// import Tooltip from "@ui/external/components/tooltip";
import { formatDateTime } from "@utils/helper/index.helper";
import { ColumnType } from "@utils/interface/index.interface";
import { Button } from "@components/ui/button";
import { CalendarIcon, PencilIcon } from "lucide-react";
import CricketPopOver from "@pages/dashboard/marketingEvents/_components/CricketPopOver";
import CricketDialog from "@pages/dashboard/marketingEvents/_components/CricketDialog";
import AddMatchForm from "../form/index.form";
import CricketFlag from "../../_components/CricketFlag";

export type MatchesType = {
  id: number;
  cricket_team1: {
    id: number;
    name: string;
    iso_code: string;
  };
  cricket_team2: {
    id: number;
    name: string;
    iso_code: string;
  };
  stage: string;
  match_number: string;
  match_start_time: string;
  match_end_time: string;
  status: string;
  created_date: string;
  created_date_time: string;
  updated_date_time: string;
  toss_winner: {
    id: number;
    name: string;
    iso_code: string;
  };
  match_winner: {
    id: number;
    name: string;
    iso_code: string;
  };
  player_of_the_match: {
    id: number;
    name: string;
  };
};

const ColumnList = () => {
  // Helper function for status badge styling
  const getStatusStyles = (status: string) => {
    const normalizedStatus = status?.toLowerCase().trim();

    switch (normalizedStatus) {
      case "prediction_open":
        return {
          backgroundColor: "#22c55e",
          color: "#ffffff",
        };
      case "prediction_closed":
        return {
          backgroundColor: "#f3f4f6",
          color: "#4b5563",
        };
      // case 'upcoming':
      //   return {
      //     backgroundColor: '#f59e0b',
      //     color: '#ffffff',
      //   };
      default:
        return {
          backgroundColor: "#f59e0b",
          color: "#ffffff",
          showIcon: false,
        };
    }
  };

  const renderStatusBadge = (status: string) => {
    const styles = getStatusStyles(status);

    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          padding: "8px 20px",
          borderRadius: "24px",
          backgroundColor: styles.backgroundColor,
          color: styles.color,
          fontSize: "16px",
          fontWeight: "500",
          whiteSpace: "nowrap",
        }}
      >
        {status}
        {styles.showIcon && (
          <span style={{ fontSize: "12px", marginLeft: "2px" }}>▲</span>
        )}
      </div>
    );
  };

  const column: ColumnType<MatchesType>[] = [
    // {
    //   name: "ID",
    //   cell: (row) => (
    //     <span className="font-semibold text-gray-700">{row.id}</span>
    //   ),
    //   sortable: true,
    // },
    {
      name: "ID",
      cell: (row) => {
        console.log("This is the ID:", row.id);
        return <span className="font-semibold text-gray-700">{row.id}</span>;
      },
      sortable: true,
    },
    {
      name: "Team 1",
      cell: (row) => (
        <p className="flex gap-2 items-center">
          <CricketFlag
            isoCode={row.cricket_team1.iso_code}
            className="text-2xl w-8 h-8"
            title={row.cricket_team1.name}
          />
          {row?.cricket_team1.name}
        </p>
      ),
    },
    {
      name: "Team 2",
      cell: (row) => (
        <p className="flex gap-2 items-center">
          <CricketFlag
            isoCode={row.cricket_team2.iso_code}
            className="text-2xl w-8 h-8"
            title={row.cricket_team2.name}
          />
          {row?.cricket_team2.name}
        </p>
      ),
      sortable: true,
    },
    {
      name: "Match Order",
      cell: (row) => (
        <div>
          <p className="text-xl">{row?.stage}</p>
          <p>{row?.match_number} out of 55</p>
        </div>
      ),
      sortable: false,
    },
    {
      name: "Start-Time",
      cell: (row) => (
        <div>
          <p>
            {row?.match_start_time
              ? formatDateTime(row.match_start_time)
              : "N/A"}
          </p>
        </div>
      ),
      sortable: false,
    },
    {
      name: "End-Time",
      cell: (row) => (
        <div>
          <p>
            {row?.match_end_time ? formatDateTime(row.match_end_time) : "N/A"}
          </p>
        </div>
      ),
      sortable: false,
    },
    {
      name: "Status",
      cell: (row) => renderStatusBadge(row?.status),
      sortable: false,
    },

    {
      name: "Actions",
      cell: (row) => (
        <div className=" cursor-pointer">
          <CricketPopOver>
            <CricketDialog
              title="Edit Cricket Match"
              trigger={
                <div className="flex gap-2 items-center">
                  <PencilIcon size={13} className="-mt-[2px]" />
                  <p>Edit</p>
                </div>
              }
            >
              <AddMatchForm formdata={row} />
            </CricketDialog>
          </CricketPopOver>
          {/* <CricketPopOver>
            
           
          </CricketPopOver> */}
        </div>
      ),
      sortable: false,
    },
  ];
  return column;
};

export { ColumnList };
